export function fullscreen() {
  // angular.element('#fullscreen-btn-hidden').click();
  // let keyboard = angular.element('.keyboardInputMaster');
  // if (keyboard.length) {
  //   keyboard.appendTo('.fullscreen-container');
  // }

  if ((document.fullScreenElement && document.fullScreenElement !== null) ||    
    (!document.mozFullScreen && !document.webkitIsFullScreen)) {
    if (document.documentElement.requestFullScreen) {  
      document.documentElement.requestFullScreen();  
    } else if (document.documentElement.mozRequestFullScreen) {  
      document.documentElement.mozRequestFullScreen();  
    } else if (document.documentElement.webkitRequestFullScreen) {  
      document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);  
    }  
  } else {  
    if (document.cancelFullScreen) {  
      document.cancelFullScreen();  
    } else if (document.mozCancelFullScreen) {  
      document.mozCancelFullScreen();  
    } else if (document.webkitCancelFullScreen) {  
      document.webkitCancelFullScreen();  
    }  
  }

  // var element = document.getElementById('panel-agenda');
  // if (element) element.classList.remove('fullscreen');

}

export function isObjectEmpty(o) {
  if (!o) return true;
  return Object.keys(o).length === 0;
}

export function logoutInMap(localStorageService) {
  let caja = localStorageService.get('caja');
  localStorage.clear();
  localStorageService.set('caja', caja);
}

/** 
 * Cierra la sesión actual.
 */
export function logout(localStorageService, $window) {
  logoutInMap(localStorageService);
  $window.location.reload();
}


// WEBPACK FOOTER //
// ./src/core/util/general.js